import './index.scss'
import _ from 'lodash'
import '../../assets/scripts/myNiceScroll'
import {resizeScroll} from '../../assets/scripts/myNiceScroll'

if($('.common-list').length > 0){
  // 查看更多
  if($(window).width() > 992){
    var cmListinitshowliNum = 3
    var cmListshowstep = 3
  }else{
    var cmListinitshowliNum = 2
    var cmListshowstep = 2
  }
  var cmListclickNum = 0
  var cmListtotalli = $('.common-list ul li').length

  if (cmListtotalli <= 3 && $(window).width() > 992 || cmListtotalli <= 2 && $(window).width() <= 992) {
      $('.common-list .common-more-btn').hide()
  }

  $('.common-list .common-more-btn').on('click', function () {
    cmListclickNum += 1
      if (cmListinitshowliNum + cmListshowstep * cmListclickNum < cmListtotalli) {
          for (let i = 0; i < cmListshowstep; i++) {
              $('.common-list ul li').eq(cmListinitshowliNum + (cmListclickNum - 1) * cmListshowstep + i).show()
          }
      } else {
          for (let i = 0; i < cmListtotalli - cmListclickNum * cmListshowstep; i++) {
              $('.common-list ul li').eq(cmListinitshowliNum + (cmListclickNum - 1) * cmListshowstep + i).show()
          }
          $('.common-list .common-more-btn').hide()
      }
      resizeScroll()
  })
}

// 搜索效果
//鼠标经过显示子菜单
var mouseover_tid = [];
var mouseout_tid = [];
$(document).ready(function () {
  $(".common-search-bar .search-bar .left-nav ul li").each(function (index) {
    $(this).hover(
      // 鼠标进入
      function () {
        var _self = this;
        // 停止卷起事件
        clearTimeout(mouseout_tid[ index ]);
        // 当鼠标进入超过 0.2 秒, 展开菜单, 并记录到线程 ID 中
        mouseover_tid[ index ] = setTimeout(function () {
          $(_self).addClass('show');
        }, 201);
      },
      // 鼠标离开
      function () {
        var _self = this;
        // 停止展开事件
        clearTimeout(mouseover_tid[ index ]);
        // 当鼠标离开超过 0.2 秒, 卷起菜单, 并记录到线程 ID 中
        mouseout_tid[ index ] = setTimeout(function () {
          $(_self).removeClass('show');
        }, 201);
      });
    });
});

//点击子菜单子项，添加横线，显示loading，添加tag
$('.common-search-bar .search-bar .left-nav ul li .sub-nav a').on('click',function(){
  // $(this).addClass('on')
  // $('.loading').fadeIn(300)
  // $('.common-search-bar .search-bar .left-nav ul li').removeClass('show')

  // let tag = $(this).attr('data-value')
  // let html = `<div class="tag">
  //               <span>${tag}</span>
  //               <i class="iconfont icon-guanbi"></i>
  //             </div>`
  // $('.common-search-bar .search-tag').append(html)

  resizeScroll()

  // setTimeout(function(){
  //   $('.loading').fadeOut(300)
  // },800)
})

//点击tag叉号，删除tag，删除子菜单子项横线
$('.common-search-bar .search-tag').on('click','.tag .iconfont',function(){
  // $(this).parents('.tag').remove()
  resizeScroll()

  // let value = $(this).siblings('span').html()
  // $('.common-search-bar .search-bar .left-nav ul li .sub-nav a[data-value='+ value +']').removeClass('on')
})